import { gql } from "@apollo/client";

export const CREATE_EVENT = gql`
  mutation createEvent($input: EventInput!) {
    createEvent(input: $input) {
      id
      eventName
      date
      city
      state
      country
      eventLocation
      image
      startDate
      endDate
      visibility
      description
      eventType
      sponsorshipTitle
      durationMinutes
      bufferMinutes
      capacity
      timezone
      dailyStartTime
      dailyEndTime
      breakStartTime
      breakEndTime
      dailySchedule {
        date
        startTime
        endTime
        breakStartTime
        breakEndTime
      }
      fullPaymentAtBooking
    }
  }
`;

export const UPLOAD_EVENT_IMAGE = /* GraphQL */ `
  mutation uploadEventImage($id: ID!, $input: UploadEventImageInput!) {
    uploadEventImage(id: $id, input: $input) {
      id
      image
      eventName
      city
      state
      country
      date
      eventLocation
      startDate
      endDate
    }
  }
`;

export const UPDATE_EVENT = /* GraphQL */ `
  mutation updateEvent($id: ID!, $input: UpdateEventInput!) {
    updateEvent(id: $id, input: $input) {
      id
      eventName
      date
      city
      state
      country
      eventLocation
      startDate
      endDate
      image
      visibility
      description
      eventType
      sponsorshipTitle
      durationMinutes
      bufferMinutes
      capacity
      timezone
      dailyStartTime
      dailyEndTime
      breakStartTime
      breakEndTime
      dailySchedule {
        date
        startTime
        endTime
        breakStartTime
        breakEndTime
      }
      fullPaymentAtBooking
    }
  }
`;

// Slim variant for the EventCard visibility toggle. Selecting only the fields
// we change lets the optimisticResponse be complete, so Apollo doesn't log
// missing-field warnings or write a partial cache entry.
export const UPDATE_EVENT_VISIBILITY = /* GraphQL */ `
  mutation updateEventVisibility($id: ID!, $input: UpdateEventInput!) {
    updateEvent(id: $id, input: $input) {
      id
      visibility
    }
  }
`;

export const DELETE_EVENTS = gql`
  mutation EventMutation($ids: [ID!]!) {
    deleteEvent(ids: $ids) {
      id
    }
  }
`;
